import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';

@Component({
  selector: 'app-content-accordeon',
  imports: [MatExpansionModule],
  templateUrl: './content-accordeon.component.html',
  styleUrl: './content-accordeon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentAccordeonComponent {
  readonly datatitle = input<string>();
  readonly isopen = input(false, { transform: (v: string | boolean) => !!v }); // legacy
  readonly dataisopen = input(false, { transform: (v: string | boolean) => v === 'true' || v === true });
}
